module.exports = __webpack_public_path__ + "static/img/si.31fbdc5b.svg";